import { Eye, X, ExternalLink, Loader2 } from "lucide-react";
import { QuestionChangePreview } from "@/components/QuestionChangePreview";
import { JobPreview } from "@/components/copilot/JobPreview";
import { PreviewJourney } from "@/components/copilot/NextStep";
import { jobIdOf } from "@/components/copilot/useJourney";

function Body({ session, previewUrl, busy, dragging, job, onDecisionBusy, onSession }) {
  if (session?.refinement) return <QuestionChangePreview key={session.refinement.id} session={session} busy={busy} onDecisionBusy={onDecisionBusy} onSession={onSession} />;
  if (jobIdOf(previewUrl)) return <JobPreview job={job} />;
  if (previewUrl) return <iframe key={`${previewUrl}-${session?.preview_rev || 0}`} title="Workspace preview" data-testid="ai-preview-frame"
    src={`${previewUrl}${previewUrl.includes("?") ? "&" : "?"}embedded=1`} className="w-full flex-1 min-h-0 border-0" style={dragging ? { pointerEvents: "none" } : undefined} />;
  return <div className="p-8 text-sm text-muted-foreground" data-testid="ai-preview-empty"><Eye className="h-8 w-8 text-primary mb-4" />Your workspace appears here when there is a role, profile or other result to preview. Keep chatting on the left.</div>;
}

const titleOf = (url) => jobIdOf(url) ? "Job preview" : /\/recruiter\/jobs\/[^/]+\/test/.test(url || "") ? "Assessment preview" : "Workspace preview";

export function CopilotPreview({ onClose, ...props }) {
  const { previewUrl, busy, job, session } = props;
  return (
    <section className="ai-preview-panel h-full w-full" data-testid="ai-preview-panel">
      <div className="ai-preview-head">
        <span className="text-xs font-medium flex items-center gap-2 shrink-0" data-testid="ai-preview-title">
          {titleOf(previewUrl)}
          {busy && previewUrl && <span className="inline-flex items-center gap-1.5 text-primary font-normal" data-testid="ai-preview-updating"><Loader2 className="h-3 w-3 motion-safe:animate-spin" /> Updating…</span>}
        </span>
        {job && !session?.refinement ? <PreviewJourney job={job} /> : <span className="flex-1" />}
        <div className="flex items-center gap-1 shrink-0">
          {previewUrl && <a href={previewUrl} target="_blank" rel="noopener noreferrer" aria-label="Open preview in a new browser tab" title="Open in a new tab" data-testid="ai-preview-external" className="ai-icon-button"><ExternalLink className="h-4 w-4" /></a>}
          <button onClick={onClose} data-testid="ai-preview-close" aria-label="Close preview" title="Close preview" className="ai-icon-button"><X className="h-4 w-4" /></button>
        </div>
      </div>
      <Body {...props} />
    </section>
  );
}
